module.exports = {
  COMMENT_TYPES: {
    KYC_INDIVIDUAL: 'KYC_INDIVIDUAL',
    KYC_COMPANY: 'KYC_COMPANY',
  },
}
